import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from './agente-financeiro.model';
import { BaseModel } from './base-model.model';
import { LimitePagamentoEcgTerceiro } from './limite-pagamento-ecg-terceiro';

export class LimiteAgenteFinanceiro extends BaseEntity {
    public agenteFinanceiro: AgenteFinanceiro;
	public valorLimite: LimiteContratacao;
	public valorLimiteEspecial?: LimiteContratacao;
	public modalidade: string;
	public valorLimiteMaximo: number; // tem relacao com o limite especial
    public ideTranche: number;

    public historico: HistoricoLimiteAgenteFinanceiro[];

    constructor(agenteFinanceiro?: AgenteFinanceiro, valorLimite?: LimiteContratacao, modalidade?: string, valorLimiteMaximo?: number) {
    	super();
		this.agenteFinanceiro = agenteFinanceiro;
		this.valorLimite = valorLimite;
		this.modalidade = modalidade;
		this.valorLimiteMaximo = valorLimiteMaximo;
	}
}

export class HistoricoLimiteAgenteFinanceiro extends BaseModel{
    public id: number;
    public dataCriacao: String;
    public usuarioResponsavel: String;
    public valorLimiteContratacao: number;
    public valorLimiteEspecial: number;
    public valorLimiteInicial: number;
    public valorLimiteMaximo: number;
}

export class LimiteContratacao {
	constructor(total?: number, utilizado?: number, disponivel?: number) {
		this.valorLimiteTotal = total;
		this.valorLimiteUtilizado = utilizado;
		this.valorLimiteDisponivel = disponivel;
	}

	public valorLimiteDisponivel: number;
	public valorLimiteTotal: number;
	public valorLimiteUtilizado: number;
    public valorCedidoPgtoEcg; number
}

export class LimiteEspecial {
	public limiteMinimo: number;
	public ativo: boolean;
}

export class LimitesFundo {
    public numeroTranche: number;
	public global:LimiteContratacao;
	public especial:LimiteEspecial;
	public grandesEmpresas:LimiteContratacao;
    public limitesAdicionais: LimiteAdicionalCesta[];
    public listaLimitePagamentoEcgTerceiroDTO:LimitePagamentoEcgTerceiro[];
}

export class LimiteAdicionalCesta {
  public ideLimiteAdicionalTranche: number;
  public nome: string;
  public dataInicioValidade: Date;
  public valorLimite: LimiteContratacao;
}

export class LimiteFundoCadastro extends BaseModel {
    public dataReferencia: Date;
    public valorTotalLimiteContratacao: Date;
	public valorTotalRecursosFundo: number;
	public comentarios: string;
}

export class HistoricoLimiteFundoCadastro extends BaseModel {
    public dataCriacao: Date;
    public usuarioResponsavel: string;
    public dataReferencia: Date;
    public valorTotalLimiteContratacao: Date;
	public valorTotalRecursosFundo: number;
	public comentarios: string;
}

export class LimiteHonraAgenteFinanceiro extends BaseEntity {
    public agenteFinanceiro: AgenteFinanceiro;
    public ide: number;
	public liberadoMicroemprendedorIndividualEmpresas: number;
	public liberadoMicroEmpresas: number;
	public liberadoEmpresasPequenas: number;
	public liberadoEmpresasMedias: number;
	public liberadoEmpresasGrandes: number;
    public vlo: number;
    public vho: number;
    public vro: number;
    public coberturaMaximaInadimplencia: number;
    public fatorRedutor: number;
    public limiteDisponivel: number;
    public cmiAposFator: number;
    public cmiAposRcmi: number;
    public valorRcmi: number;

    constructor(agenteFinanceiro?: AgenteFinanceiro,
        liberadoEmpresasPequenas?: number, liberadoEmpresasMedias?: number,
        vlo?: number, vho?: number, vro?: number, coberturaMaximaInadimplencia?: number,
        fatorRedutor?: number, limiteDisponivel?: number) {

        super();
        this.agenteFinanceiro = agenteFinanceiro;
        this.liberadoEmpresasPequenas = liberadoEmpresasPequenas;
        this.liberadoEmpresasMedias = liberadoEmpresasMedias;
        this.vlo = vlo;
        this.vho = vho;
        this.vro = vro;
        this.coberturaMaximaInadimplencia = coberturaMaximaInadimplencia;
        this.fatorRedutor = fatorRedutor;
        this.limiteDisponivel = limiteDisponivel;
    }
}
